import {
  Link,
  useLocation,
  useMatch,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import PaginationLayout from "../components/PaginationLayout";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Carousel from "react-bootstrap/Carousel";
import placeholder from "../assets/images/profile_placeholder.png"

import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import moment from "moment";
import { getUserProfileImage } from "../utils/constant_value";
import Swal from "sweetalert2";
import VideoPlayer from "../components/hslVideoPlayer";

function Posts() {
  const location = useLocation();
  const match = useMatch("/posts/:page");
  const navigate = useNavigate();
  const param = useParams();
  const { authState, scrollToTop, handleError, handleFilter, handlePagination } =
    useContext(GlobalContext);
  henceforthApi.setToken(authState.access_token);
  const [loading, setLoading] = useState(false);
  const [postsData, setPostsData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  let limit = 9;
  const [photoIndex, setPhotoIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)
  const [lightboxImages, setLightboxImages] = useState([])
  const initialiseLightBox = (data) => {
    setPhotoIndex(0)
    setIsOpen(true)
    setLightboxImages(data)
  }

  const fetchPosts = async () => {
    try {
      setLoading(true);
      let q = query.toString();
      const postRes = await henceforthApi.Posts.pagination(
        q,
        Number(param.page) - 1,
        limit
      );
      setTotalCount(postRes.count);

      setPostsData(postRes.posts);
      // console.log("PostsData", postRes.posts);
      setLoading(false);
    } catch (error) {
      handleError(error)
      setLoading(false);
      // console.log("Error while fetching data", error);
    }
  };
  // console.log("TOtalData", totalCount);
  //Modal
  const [like, setLike] = useState(false);
  const [comment, setComment] = useState(false);
  const [Tag, setTags] = useState(false);
  const [Coin, setCoin] = useState(false);
  const handleCloseTags = () => setTags(false);
  const handleCloseCoin = () => setCoin(false);
  //Filter
  var query = new URLSearchParams(location.search);
  const filters = [
    { name: "Live", value: "Live" },
    // { name: "Deleted", value: "Deleted" },
    { name: "Activated", value: "Activated" },
    { name: "Deactivated", value: "Deactivated" },
  ];

  const [manageMedias, setManageMedias] = useState({
    type: "",
    _id: "",
    admin_verified: false,
    language: "ENGLISH",
    account_status: "",
  });

  //Remove
  const [showRemove, setShowRemove] = useState(false);
  const handleConfirm = (id) => {
    // console.log(id);
    setShowRemove(id);
  }
  const handleRemove = async (id) => {
    // console.log(id)
    try {
      await henceforthApi.Posts.delete(id);
      setShowRemove(false);
      fetchPosts();
    } catch (Error) {
      // console.log("Error while removing posts", Error);
    }
    setShowRemove(false)
  };
  //Tags
  const [getTags, setGetTags] = useState([]);
  const HandleTags = async (Tag) => {
    // console.log(Tag);
    setTags(true);
    try {
      const TagsResponse = await henceforthApi.Posts.tags(Tag);
      setGetTags(TagsResponse);
    } catch (error) {
      // console.log("Tags Error", error);
    }
  };
  // console.log("TagsResponse", getTags);
  //Coins
  const [getCoins, setGetCoins] = useState([]);
  const [totalCoins, setGetTotalCoins] = useState({});
  const HandleCoins = async (Coin) => {
    // console.log(Coin);
    setCoin(true);
    try {
      const CoinsResponse = await henceforthApi.Posts.coins(Coin);
      setGetCoins(CoinsResponse);
      setGetTotalCoins(CoinsResponse);
    } catch (error) {
      // console.log("Coins Error", error);
    }
  };
  //Like
  const [getLike, setGetLike] = useState([]);
  const HandleLike = async (like) => {
    setLike(true);
    try {
      const likeResponse = await henceforthApi.Posts.like(like);
      setGetLike(likeResponse);
    } catch (error) {
      // console.log("LikeError", error);
    }
  };
  // console.log("likeResponse", getLike);
  //Comment
  const [getComment, setGetComment] = useState([]);
  const HandleComment = async (LC) => {
    setComment(true);
    try {
      const CommentResponse = await henceforthApi.Posts.Comment(LC);
      setGetComment(CommentResponse);
    } catch (error) {
      // console.log("CommentError", error);
    }
  };
  useEffect(() => {
    scrollToTop();
    fetchPosts();
  }, [param.page, query.get("filter"), manageMedias]);
  return (
    <>
      <div class="row animated fadeInRight">
        <div class="col-md-12">
          <div>
            {isOpen && <Lightbox
              mainSrc={`${henceforthApi.API_FILE_ROOT_ORIGINAL}${lightboxImages[photoIndex].media_url}`}
              nextSrc={lightboxImages[(photoIndex + 1) % lightboxImages.length]}
              prevSrc={lightboxImages[(photoIndex + lightboxImages.length - 1) % lightboxImages.length]}
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex((photoIndex + lightboxImages.length - 1) % lightboxImages.length)
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % lightboxImages.length)
              }
            />}
          </div>
          <div className="ibox">
            <div className="ibox-title d-flex align-items-center justify-content-between">
              <h5 style={{ fontSize: "16px" }} className="m-0 fw-bold">
                List of all posts
              </h5>
              <div className="dropdown theme me-3">
                <button
                  className="btn dashboard-button pe-4 ps-4 dropdown-toggle shadow-none"
                  id="sortDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {filters.filter((res) => res.value == query.get("filter"))
                    .length
                    ? filters.filter(
                      (res) => res.value === query.get("filter")
                    )[0].name
                    : "All"}
                  {/* <i
                className="fas fa-chevron-down bi-chevron-down ms-2 "
                style={{ fontSize: "12px" }}
              ></i> */}
                </button>
                <ul
                  className="dropdown-menu share-icons"
                  aria-labelledby="sortDropdown"
                >
                  {query.has("filter") && (
                    <li className="cursor-pointer">
                      <a
                        className="dropdown-item"
                        onClick={() => handleFilter("filter", "")}
                      >
                        All
                      </a>
                    </li>
                  )}
                  {filters.map((res) => {
                    return (
                      <li key={res.value} className="cursor-pointer">
                        <a
                          className="dropdown-item"
                          onClick={() => handleFilter("filter", res.value)}
                        >
                          {res.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="ibox-content">
              <div>
                <div className="row">
                  {!loading && !postsData?.length ? <div className="text-center"> <b>No Posts Found </b>  </div> : postsData?.map((item, index) => {
                    // console.log(item,"resssssssssssssssssssssssssssss")
                    return < div
                      class="col-12 col-sm-6 col-xl-4 cardAll mb-4"
                      key={index}
                      sx={{ height: "100%" }}
                    >
                      <div class="card mb-4 box-shadow border-0 shadow h-auto">
                        <div className="explore-img post-slider-image">
                          <Carousel
                            interval={null}
                            indicators={item?.post_medias?.length > 1}
                            controls={item?.post_medias?.length > 1}
                          >
                            {item?.post_medias?.length ? (
                              item?.post_medias.map((res, index) => (
                                <Carousel.Item key={index}>
                                  {(res?.media_type === "VIDEO/MP4" || res?.media_type === "VIDEO") ? (
                                    <VideoPlayer src={res?.media_url} />
                                  ) : (
                                    <img
                                      className="w-full object-cover object-center cursor-pointer"
                                      src={res.media_url ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${res?.media_url}` : ""}
                                      alt="PostImage"
                                      onClick={() => initialiseLightBox(item?.post_medias)}

                                    />
                                  )}
                                </Carousel.Item>
                              ))
                            ) : (
                              <img
                                className="d-block w-100"
                                src={placeholder}
                                alt="PostImage"
                                style={{ cursor: "pointer" }}
                              />
                            )}
                          </Carousel>

                        </div>
                        <div class="card-body">
                          {/* <div>
                            <h2
                              className="fw-bolder m-0"
                              style={{ fontSize: "16px" }}
                            >
                            </h2>
                          </div> */}
                          <div className="username-box my-1 d-flex justify-content-between align-items-center">
                            <div className="d-flex gap-1 ProfileImagePRS-box">
                              <img className="ProfileImagePRS" src={getUserProfileImage(item?.profile_pic)} alt="" />
                              <Link
                                to={`/user/${item?.user_id}/1/1?type=posts`}
                                className="Details_of_User"
                              >
                                <p className="fw-bolder m-0" style={{ fontSize: "14px", whiteSpace: 'nowrap' }}>
                                  {item?.name}
                                </p>
                              </Link >
                            </div>
                            <div>
                              <label className="PublicPrivate">
                                <i
                                  class={item?.is_private == false ?
                                    `fas fa-globe-africa` : `fas fa-lock`}
                                  style={{ marginRight: "3px" }}
                                ></i>
                                {item?.is_private == false
                                  ? "Public"
                                  : "Private"}
                              </label>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-6">
                              <div className="desc-box" style={{ minHeight: "45px" }}>
                                <p className="m-0" style={{ fontSize: "14px" }}>
                                  <b>Description:</b>
                                  <span title={item?.description}>{item?.discription}</span>
                                </p>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="text-end">
                                <label className={item.status == "Active" ? "custom-status" : "custom-status-deactivate"}>
                                  {item.status}
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="my-3 flex justify-between items-center text-sm font-semibold cursor-pointer">
                            <h6 onClick={() => HandleTags(item._id)}>
                              Tags:
                              <span className="font-bold ml-1">{item.tags_count}</span>
                            </h6>

                            <h6 onClick={() => HandleComment(item._id)}>
                              Comments:
                              <span className="font-bold ml-1">{item.comments_count}</span>
                            </h6>

                            <h6 onClick={() => HandleLike(item._id)}>
                              Likes:
                              <span className="font-bold ml-1">{item.likes_count}</span>
                            </h6>
                          </div>
                          {/* <h6
                                onClick={() => HandleCoins(item._id)}
                                className="text-sm cursor-pointer"
                              >
                                Coins:
                                <span className="font-bold ml-1">
                                  <i className="fas fa-usd-circle mr-1 text-base"></i>
                                  {item.coins_count}
                                </span>
                              </h6> */}


                          <hr />
                          <div className="row align-items-center flex-wrap  py-2">

                            <div className="col-7">
                              <div class="d-flex justify-content-between align-items-center">
                                <div class="btn-group">
                                  <div className="bown-num ">
                                    <p className="m-0">
                                      <small style={{ whiteSpace: "" }}>
                                        {moment(Number(item.created_at)).format(
                                          "DD MMM YYYY, h:mm a"
                                        )}
                                      </small>
                                    </p>
                                  </div>
                                  <div className="bown-num"></div>
                                </div>
                              </div>
                            </div>

                            <div className="col-5">
                              <div className="d-flex justify-content-end">
                                <div>
                                  <Link to={`/media/${item._id}/like`}>
                                    <div className="">
                                      <button
                                        onClick={() => handleConfirm(item._id)}
                                        style={{ float: "right" }}
                                        className="btn mt-2 btn-outline-dark"
                                      >
                                        Details
                                      </button>
                                    </div>
                                  </Link>
                                </div>
                                {/* <div>
                                    <button
                                      onClick={() => handleActivate(item?._id, item?.status)}
                                      style={{ float: "right" }}
                                      className="btn btn-danger"
                                    >
                                      {item?.status == "Active" ? "Active" : "Deactive"}
                                    </button>
                                  </div> */}
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                      <Modal
                        show={showRemove}
                        onHide={() => setShowRemove(false)}
                        backdrop="static"
                        keyboard={false}
                        centered
                        scrollable
                        className="confirm-box-modal"
                      >
                        <Modal.Header>
                          <Modal.Title>
                            Remove
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="my-3 text-center">
                            Do you want to Remove?
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button onClick={() => setShowRemove(false)} className="px-6 confirm-btn">
                            No
                          </Button>
                          <Button onClick={() => handleRemove(showRemove)} className="px-6 confirm-btn">
                            Yes
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  })}
                </div>
                <div>
                </div>
                <div>
                  {/* LIke */}
                  <Modal
                    show={like}
                    onHide={() => setLike(false)}
                    centered
                    scrollable
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>
                        Likes
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {getLike?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Likes</div> : getLike?.data?.map((item, index) => (
                        <>
                          <div
                            className="modal-wrapper d-flex align-items-center  mx-2"
                            key={index}
                          >
                            <img
                              src={getUserProfileImage(item?.profile_pic)}
                              alt="ProfileImage"
                              class="modal-profile me-2"
                            />
                            <Link
                              to={`/user/${item?.user_id}/1/1?type=posts`}
                              className="Details_of_User"
                            >
                              <p className="mb-0 profile-name">{item.name}</p>
                            </Link>
                          </div>
                          < hr />
                        </>
                      ))}
                    </Modal.Body>
                  </Modal>
                  {/* Comment */}
                  <Modal
                    show={comment}
                    onHide={() => setComment(false)}
                    centered
                    scrollable
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>
                        Comment
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {getComment?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Comments</div> : getComment?.data?.map((item, index) => (
                        <>
                          <div
                            className="image-name-box d-flex gap-2 align-items-start w-100"
                            key={index}
                          >
                            <div className="image-box">
                              <img
                                src={getUserProfileImage(item?.profile_pic)}
                                alt="ProfileImage"
                                class="modal-profile align-items-start"
                              />
                            </div>

                            <div className="name-box w-100">
                              <div className="d-flex align-items-center justify-content-between ">
                                <div>
                                  <Link
                                    to={`/user/${item?.user_id}/1/1?type=posts`}
                                    className="Details_of_User"
                                  >
                                    <p className="mb-0 profile-name">
                                      {item.name}
                                    </p>
                                  </Link>
                                </div>
                                <div className="">
                                  <p
                                    className="m-0"
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {moment(Number(item.created_at)).format(
                                      "DD MMM YYYY, h:mm a"
                                    )}
                                  </p>
                                </div>
                              </div>
                              <p
                                className="m-0"
                                style={{
                                  fontSize: "12px",
                                }}
                              >
                                {item.comments}
                              </p>
                            </div>
                          </div>
                          <hr />
                        </>
                      ))}
                    </Modal.Body>
                  </Modal>
                </div>
                <div>
                  <Modal
                    show={Tag}
                    onHide={handleCloseTags}
                    centered
                    scrollable
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>
                        <Link
                          to=""
                          style={{
                            textDecoration: "none",
                            color: "#000000",
                            cursor: "auto",
                          }}
                        >
                          Tags
                        </Link>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {getTags?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Tags</div> : getTags?.tagged_users?.map((item, index) => (
                        <>
                          <div>
                            <div className="modal-wrapper d-flex align-items-center  mx-2" key={index}>
                              <img
                                src={getUserProfileImage(item?.profile_pic)}
                                alt="ProfileImage"
                                class="modal-profile me-2"
                              />
                              <Link
                                to={`/user/${item.user_id}/1/1?type=posts`}
                                className="Details_of_User"
                              >
                                <p className="mb-0 profile-name">
                                  {item?.full_name}
                                </p>
                              </Link>
                            </div>
                          </div>
                          <hr />
                        </>
                      ))}
                    </Modal.Body>
                  </Modal>
                </div>
                <div>
                  <Modal
                    show={Coin}
                    onHide={handleCloseCoin}
                    centered
                    scrollable
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>
                        <Link
                          to=""
                          style={{
                            textDecoration: "none",
                            color: "#000000",
                            cursor: "auto",
                          }}
                        >
                          Coins
                        </Link>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="row">
                        {getCoins?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Coins</div> : getCoins?.data?.map((item, index) => (
                          <div className="col-sm-12 ">
                            <div
                              className="image-name-box d-flex gap-2 align-items-right justify-content-between px-3"
                              key={index}
                            >
                              <div className="d-flex gap-2 align-items-center">
                                <div className="image-box">
                                  <img
                                    src={getUserProfileImage(item?.users?.profile_pic)}
                                    alt="ProfileImage"
                                    class="modal-profile"
                                  />
                                </div>

                                <div className="name-box">
                                  <Link
                                    to={`/user/${item.users?._id}/1/1?type=posts`}
                                    className="Details_of_User"
                                  >
                                    <p className="mb-0 profile-name">
                                      {item?.users?.full_name}
                                    </p>
                                  </Link>
                                  <div>
                                    <p
                                      className="m-0"
                                      style={{
                                        fontSize: "10px",
                                      }}
                                    >
                                      {moment(
                                        Number(item?.users?.created_at)
                                      ).format("DD MMM YYYY, h:mm a")}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div className="image-name-box">
                                <p>
                                  <i
                                    style={{ marginRight: "2px" }}
                                    class="fas fa-usd-circle"
                                  ></i>
                                  {item?.coins}
                                </p>
                              </div>
                            </div>
                            <hr />
                          </div>
                        ))}
                        {totalCoins?.coins_count == 0 ? " " :
                          <>
                            <div className="col-sm-8 d-flex gap-2 align-items-center">
                              <h6 style={{ fontWeight: "bold" }} className="ps-3">
                                Total Received :
                              </h6>
                            </div>
                            <div className="col-sm-4">
                              <dt className="text-end pe-3">
                                <i
                                  style={{ marginRight: "2px" }}
                                  class="fas fa-usd-circle"
                                ></i>
                                {totalCoins?.coins_count}
                              </dt>
                            </div>
                          </>
                        }
                      </div>
                    </Modal.Body>
                  </Modal>
                </div>
              </div>

              <PaginationLayout
                count={totalCount}
                data={postsData}
                page={Number(param.page)}
                limit={Number(limit)}
                loading={loading}
                onPageChange={(val) => handlePagination(val)}
              />

            </div>
          </div>
        </div >
      </div >
    </>
  );
}

export default Posts;
